import React, { useMemo } from 'react';
import { Card, ProgressBar } from 'react-bootstrap';
import { ConfigMapping, Props } from './acquisitionsProgressCard.type';
import { Acquisition } from 'pages/recruiterDashboard/recruiterDashboard.type';

const acquisitionsConfig: ConfigMapping = {
  applications: {
    label: 'Application',
    color: '#A048D3'
  },
  onHold: {
    label: 'On-hold',
    color: '#FDB354'
  },
  rejected: {
    label: 'Rejected',
    color: '#FF4747'
  },
  shortlist: {
    label: 'Shorlisted',
    color: '#00C9DA'
  }
};

const CardItem = ({
  label,
  value,
  color
}: {
  label: string;
  value: number;
  color: string;
}) => {
  return (
    <div className="mb-3 d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center">
        <span className="progress-bold" style={{ backgroundColor: color }} />
        <span className="ms-2 text-body-tertiary">{label}</span>
      </div>
      <small>{value}%</small>
    </div>
  );
};

function AcquisitionsProgressCard({ data }: Props) {
  const acquisitionsData = useMemo(() => {
    return data
      ? Object.entries(data).map(([key, value]) => {
          const { color, label } = acquisitionsConfig[key as keyof Acquisition];
          return {
            value,
            color,
            label
          };
        })
      : [];
  }, [data]);
  return (
    <Card className="mb-3">
      <Card.Body>
        <header className="d-flex justify-content-between mb-2">
          <h4 className="text-body-tertiary">Acquisitions</h4>
          <small className="text-primary fw-bold">This Month</small>
        </header>
        <div className="mb-3">
          <ProgressBar className="mb-3 rounded-3" style={{ height: '6px' }}>
            {acquisitionsData.map(({ value, color }, idx) => (
              <ProgressBar
                now={value}
                key={idx}
                style={{ backgroundColor: color }}
              />
            ))}
          </ProgressBar>
        </div>
        <div>
          {acquisitionsData.map(({ value, color, label }, idx) => (
            <CardItem color={color} value={value} label={label} key={idx} />
          ))}
        </div>
      </Card.Body>
    </Card>
  );
}

export default AcquisitionsProgressCard;
